"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9878],{

/***/ 99878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2595);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96301);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20558);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24899);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88751);
/* harmony import */ var _store_features_locationSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56608);










const AemGridColumn = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6261), __webpack_require__.e(1695)]).then(__webpack_require__.bind(__webpack_require__, 81695)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(81695)
            ]
    }
});
const BrandHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(6352), __webpack_require__.e(4725)]).then(__webpack_require__.bind(__webpack_require__, 20030)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20030)
            ]
    }
});
const HeaderNav = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(3375), __webpack_require__.e(3874)]).then(__webpack_require__.bind(__webpack_require__, 13874)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13874)
            ]
    }
});
const Video = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2006), __webpack_require__.e(5444), __webpack_require__.e(6147)]).then(__webpack_require__.bind(__webpack_require__, 46147)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46147)
            ]
    }
});
const Carousel = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6351), __webpack_require__.e(851), __webpack_require__.e(8748)]).then(__webpack_require__.bind(__webpack_require__, 8992)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8992)
            ]
    }
});
const CarouselSlick = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(6833), __webpack_require__.e(851), __webpack_require__.e(7369)]).then(__webpack_require__.bind(__webpack_require__, 69050)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69050)
            ]
    }
});
const Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(3099)]).then(__webpack_require__.bind(__webpack_require__, 33099)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33099)
            ]
    }
});
const CustomImage = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 4733).then(__webpack_require__.bind(__webpack_require__, 64733)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64733)
            ]
    }
});
const HelpSupport = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 3204).then(__webpack_require__.bind(__webpack_require__, 3204)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3204)
            ]
    }
});
const Teaser = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(851), __webpack_require__.e(3815)]).then(__webpack_require__.bind(__webpack_require__, 20851)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20851)
            ]
    }
});
const Text = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5933).then(__webpack_require__.bind(__webpack_require__, 15933)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15933)
            ]
    }
});
const Tab = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 6210).then(__webpack_require__.bind(__webpack_require__, 36210)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(36210)
            ]
    }
});
const Embed = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 3220).then(__webpack_require__.bind(__webpack_require__, 93220)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(93220)
            ]
    }
});
const Spacer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5092).then(__webpack_require__.bind(__webpack_require__, 5092)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5092)
            ]
    }
});
const PromoBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(1481)]).then(__webpack_require__.bind(__webpack_require__, 5273)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5273)
            ]
    }
});
const AemForm = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 8237).then(__webpack_require__.bind(__webpack_require__, 88237)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(88237)
            ]
    }
});
const ProductCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(7333), __webpack_require__.e(6853), __webpack_require__.e(4263)]).then(__webpack_require__.bind(__webpack_require__, 23029)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(23029)
            ]
    }
});
const ProductCardV3 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(4685), __webpack_require__.e(6827)]).then(__webpack_require__.bind(__webpack_require__, 44685)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(44685)
            ]
    }
});
const FindingModelNumber = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(863)]).then(__webpack_require__.bind(__webpack_require__, 10863)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10863)
            ]
    }
});
const ImageV1 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 6767).then(__webpack_require__.bind(__webpack_require__, 6767)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6767)
            ]
    }
});
const InPageSearch = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(8279), __webpack_require__.e(1673), __webpack_require__.e(7169), __webpack_require__.e(3176), __webpack_require__.e(157)]).then(__webpack_require__.bind(__webpack_require__, 15240)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(15240)
            ]
    }
});
const Title = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 2804).then(__webpack_require__.bind(__webpack_require__, 92804)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(92804)
            ]
    }
});
const DynamicSearch = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 8802).then(__webpack_require__.bind(__webpack_require__, 28802)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(28802)
            ]
    }
});
const InspireVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2006), __webpack_require__.e(5444), __webpack_require__.e(5939)]).then(__webpack_require__.bind(__webpack_require__, 85939)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85939)
            ]
    }
});
const ImageCluster = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 1511).then(__webpack_require__.bind(__webpack_require__, 31511)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31511)
            ]
    }
});
const ShopTheRoomCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5781).then(__webpack_require__.bind(__webpack_require__, 75781)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75781)
            ]
    }
});
const VirtualDesignerDetails = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 2372).then(__webpack_require__.bind(__webpack_require__, 12372)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12372)
            ]
    }
});
const FindAProByZip = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(6352), __webpack_require__.e(9868)]).then(__webpack_require__.bind(__webpack_require__, 39881)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(39881)
            ]
    }
});
const StoreAppointment = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(6029), __webpack_require__.e(4185)]).then(__webpack_require__.bind(__webpack_require__, 35621)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35621)
            ]
    }
});
const ShopTheRoomDetail = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(4685), __webpack_require__.e(746), __webpack_require__.e(6188)]).then(__webpack_require__.bind(__webpack_require__, 13895)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13895)
            ]
    }
});
const RoomDetailPage = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(4685), __webpack_require__.e(4755)]).then(__webpack_require__.bind(__webpack_require__, 78971)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(78971)
            ]
    }
});
const ProductCardForUpsell = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(4075)]).then(__webpack_require__.bind(__webpack_require__, 54075)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(54075)
            ]
    }
});
const ComponentContext = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(()=>__webpack_require__.e(/* import() */ 5227).then(__webpack_require__.bind(__webpack_require__, 75227)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75227)
            ]
    }
});
const AemGrid = (props)=>{
    const { data ={} , itemKey ="" , count =0 , eventHandler ={} , fullData ={} , containerId ="" , configData ={} , ...extraProps } = props;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const componentContexts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ComponentContext);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isAuthModal)(data)) {
            dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_7__/* .setAuthModalStaticText */ .vu)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isCompareProducts)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setCompareproductsStaticText)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isNewsLetter)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setSubscribeModalContent)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isSiteWideWarning)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setSitewideWarningContent)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isNewsLetterSignUp)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setSitewideNewsLetterContent)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isToaster)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setToastContent)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isStoreFilter)(data)) {
            dispatch((0,_store_features_locationSlice__WEBPACK_IMPORTED_MODULE_9__.setStoreFilter)(data));
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isGatedContent)(data)) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__.setGatedContentData)(data));
        }
    }, [
        data
    ]);
    const { title ="" , urlNames ="" , knowledgeArticle =()=>{} , technicalSpecifications =()=>{} , myFavorites =()=>{} , myProducts =()=>{} , myGenericFiller =()=>{} , myServices =()=>{} , accountSettings =()=>{} , contactUs =()=>{} , contactUsFiller =()=>{} , pressReleaseLanding =()=>{} , findStore =()=>{} , keySpecifier =()=>{} , associateMembership =()=>{} , friendsAndFamily =()=>{} , installDesignServices =()=>{} , isScrollMarginRequired =false , changePassword =()=>{}  } = extraProps;
    const itemsOrderValue = data[":itemsOrder"] || [];
    const isWrapperRequired = _constants__WEBPACK_IMPORTED_MODULE_5__.groupedComponents === null || _constants__WEBPACK_IMPORTED_MODULE_5__.groupedComponents === void 0 ? void 0 : _constants__WEBPACK_IMPORTED_MODULE_5__.groupedComponents.every((value)=>{
        return itemsOrderValue === null || itemsOrderValue === void 0 ? void 0 : itemsOrderValue.some((val)=>{
            return val === null || val === void 0 ? void 0 : val.includes(value);
        });
    });
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isInspireVideo)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InspireVideo, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isVideo)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Video, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isSpacer)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Spacer, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isImageCluster)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageCluster, {
            data: data
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isImage)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageV1, {
            data: data
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isImageV3)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomImage, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isAemForm)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AemForm, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductCardV4)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCardForUpsell, {
            authData: data
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductcardV3)(data)) {
        const { skewId ="" , presetConfigs =""  } = data;
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "productcard-v3 productcard",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCardV3, {
                authorData: {
                    skewId,
                    presetConfigs
                },
                fullData: fullData
            })
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductcard)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCard, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isCarousel)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Carousel, {
            data: data,
            fullData: fullData,
            configData: configData
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isPromoBanner)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PromoBanner, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isSlick)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CarouselSlick, {
            fullData: fullData,
            data: data,
            configData: configData
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isTeaser)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Teaser, {
            data: data,
            fullData: fullData,
            containerId: containerId,
            configData: configData
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isText)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isInPageSearch)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InPageSearch, {
            data: data
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isTab)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tab, {
            data: data,
            itemKey: itemKey,
            ...extraProps
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isBrandHeader)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isHeaderNav)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderNav, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isHeaderNavV3)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderNav, {
            data: data,
            eventHandler: eventHandler,
            v3: true
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isEmbed)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Embed, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isFooter)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isShopTheRoomDetail)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopTheRoomDetail, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isRoomDetail)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RoomDetailPage, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isShopTheRoomCard)(data)) {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopTheRoomCard, {
            cardTitle: data === null || data === void 0 ? void 0 : data.cardTitle,
            cardHoverTitle: data === null || data === void 0 ? void 0 : data.cardHoverTitle,
            ctalink: data === null || data === void 0 ? void 0 : data.ctalink,
            landingImageLink: data === null || data === void 0 ? void 0 : data.landingImageLink,
            modelImageLink: data === null || data === void 0 ? void 0 : data.modelImageLink,
            skuIds: data === null || data === void 0 ? void 0 : data.skuIds,
            presetConfigs: (ref = data === null || data === void 0 ? void 0 : data.presetConfigs) !== null && ref !== void 0 ? ref : "{}",
            altModel: data === null || data === void 0 ? void 0 : data.altModel,
            altLanding: data === null || data === void 0 ? void 0 : data.altLanding,
            linkNewTab: data === null || data === void 0 ? void 0 : data.linkNewTab
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isCartLanding)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.landing && extraProps.landing(data);
        } else {
            return extraProps && extraProps.landingFiller && extraProps.landingFiller(data);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isUpSellContainer)(data)) {
        return extraProps && extraProps.upSellContainer && extraProps.upSellContainer(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isCheckoutLanding)(data) && !isSsr) {
        return extraProps && extraProps.checkoutView && extraProps.checkoutView(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isOrderConfirmation)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderConfirmation && extraProps.orderConfirmation(data);
        } else {
            return extraProps && extraProps.orderConfirmationTagFiller && extraProps.orderConfirmationTagFiller();
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isOrderStatus)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderStatus && extraProps.orderStatus(data);
        } else {
            return extraProps && extraProps.orderStatusFiller && extraProps.orderStatusFiller();
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isOrderHistory)(data) && !isSsr) {
        return extraProps && extraProps.orderHistory && extraProps.orderHistory(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isOrderDetails)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderDetails && extraProps.orderDetails(data);
        } else {
            return extraProps && extraProps.orderDetailsFiller && extraProps.orderDetailsFiller(data);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isPairsWellWth)(data) && !isSsr) {
        return extraProps && extraProps.pairsWellWith && extraProps.pairsWellWith(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isSharedCart)(data) && !isSsr) {
        return extraProps && extraProps.sharedCart && extraProps.sharedCart(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isShopTheRoomLandingPage)(data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: componentContexts.map((param, index)=>/*#__PURE__*/ {
                let { Component , componentProps  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                    data: data,
                    ...componentProps.isFullData ? {
                        ...componentProps,
                        fullData: fullData
                    } : componentProps
                }, "".concat(Component.name, "-").concat(index));
            })
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isBreadcrumb)(data)) {
        return extraProps && extraProps.breadCrumb && extraProps.breadCrumb(data, fullData);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductList)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productList && extraProps.productList(data, eventHandler);
        } else {
            return extraProps && extraProps.productListFiller && extraProps.productListFiller(data);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isSearch)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.searchComponent && extraProps.searchComponent(data, eventHandler);
        } else {
            return extraProps && extraProps.searchFiller && extraProps.searchFiller(data);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isHelpSupport)(data) && !isSsr) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpSupport, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isAccountSettings)(data)) {
        if (!isSsr) {
            return accountSettings(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isMyservice)(data)) {
        if (!isSsr) {
            return myServices(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isMyFavorites)(data)) {
        if (!isSsr) {
            return myFavorites(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isChangePassword)(data)) {
        if (!isSsr) {
            return changePassword(data);
        } else {
            return "Loading...";
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isMyproducts)(data)) {
        if (!isSsr) {
            return myProducts(data);
        } else {
            return myGenericFiller(data, title);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isLiterature)(data) && !isSsr) {
        return extraProps && extraProps.literature && extraProps.literature(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isTechnicalSpec)(data)) {
        return technicalSpecifications && technicalSpecifications(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductDetails)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductAccordion)(data) && !isSsr) {
        return extraProps && extraProps.productAccordion && extraProps.productAccordion(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductExfPdp)(data) && !isSsr) {
        return extraProps && extraProps.productExf && extraProps.productExf(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProductReview)(data) && !isSsr) {
        return extraProps && extraProps.review && extraProps.review(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isRegisterOffline)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProducts(data);
        } else {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isRegisterOnline)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.onlineProducts && extraProps.onlineProducts(data);
        } else {
            return extraProps && extraProps.onlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isKnowledgeArticle)(data)) {
        return extraProps && knowledgeArticle(data, urlNames);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isBrowseAllStores)(data) && !isSsr) {
        return extraProps && extraProps.browseAllStores && extraProps.browseAllStores(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isContactUs)(data)) {
        if (!isSsr) {
            return contactUs(data);
        } else {
            return contactUsFiller();
        }
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isFindingModelNumber)(data) && !isSsr) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FindingModelNumber, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isPressLanding)(data) && !isSsr) {
        return pressReleaseLanding(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isFindStore)(data) && !isSsr) {
        return findStore(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isTitle)(data) && !isSsr) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isKeySpecifier)(data)) {
        return keySpecifier(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isDynamicSearch)(data) && !isSsr) {
        const { presetConfigs: presetConfigs1 = {} , disableParts =false , enablePotraitTile =false  } = data;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicSearch, {
            presetConfigs: presetConfigs1,
            disableParts: disableParts,
            enablePotraitTile: enablePotraitTile
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isAssociateMembership)(data)) {
        return associateMembership(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isInstallDesignServices)(data) && !isSsr) {
        return installDesignServices(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isProfessionalDetail)(data) && !isSsr) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VirtualDesignerDetails, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isFriendsAndFamily)(data)) {
        return friendsAndFamily(data);
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isFindAProByZip)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FindAProByZip, {
            data: data
        }) : null;
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isStoreAppointment)(data) && !isSsr) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreAppointment, {
            data: data
        });
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.isPDPCuratedProducts)(data)) {
        return extraProps && extraProps.pdpCuratedProduct && extraProps.pdpCuratedProduct(data);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils__WEBPACK_IMPORTED_MODULE_6__.ConditionalWrapper, {
            condition: (0,_utils__WEBPACK_IMPORTED_MODULE_6__.isContainer)(data) && itemKey === _constants__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.ROOT_CONTAINER || isWrapperRequired,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames, " ").concat(isScrollMarginRequired ? "unsetPageScrollMargin" : ""),
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AemGridColumn, {
                data: data,
                itemKey: itemKey,
                count: count,
                eventHandler: eventHandler,
                containerId: containerId,
                configData: configData,
                ...extraProps
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AemGrid);


/***/ })

}]);